import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'adc-popover',
  templateUrl: './adc-popover.component.html',
  styleUrls: ['./adc-popover.component.scss'],
  standalone: false
})
export class AdcPopoverComponent {
  @Input('data') hoverText: any;
  @Input('type') type: string = 'message';
  @Output() action: EventEmitter<any> = new EventEmitter<any>;
  isPopoverVisible = false;
  popoverLeft = '0px';
  popoverTop = '0px';

  actionEvent(event: any) {
    this.action.emit(event);
  }

  onMouseOver(event: MouseEvent): void {
    const popoverElement = event.currentTarget as HTMLElement;
    const popoverRect = popoverElement.getBoundingClientRect();
    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;

    if (popoverRect.top < centerY) {
      this.popoverTop = (popoverRect.bottom + 10) + 'px'; // Adjust the 10 for spacing as needed
    } else {
      this.popoverTop = (popoverRect.top - 10 - popoverElement.offsetHeight) + 'px'; // Adjust the 10 for spacing as needed
    }

    if (popoverRect.left > centerX) {
      this.popoverLeft = (popoverRect.left - 200) + 'px'; // Adjust the 200 for the popover width
    } else {
      this.popoverLeft = (popoverRect.right + 10) + 'px'; // Adjust the 10 for spacing as needed
    }

    this.isPopoverVisible = true;
  }

  onMouseOut(): void {
    this.isPopoverVisible = false;
  }
}
